import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ArrayHelper } from './array.helper';
import { JwtHelperService } from '@auth0/angular-jwt/src/jwthelper.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from './responseMapper.function';
import { DownloadService } from '../services/download.service';
import { AuthGuardService } from '../services/auth-guard.service';
import { HomeService } from '../services/home.service';
var HomeUrlHelper = /** @class */ (function () {
    function HomeUrlHelper(router, array, downloadService, authService, homeService, httpClient) {
        this.router = router;
        this.array = array;
        this.downloadService = downloadService;
        this.authService = authService;
        this.homeService = homeService;
        this.httpClient = httpClient;
        this.jwtHelperService = new JwtHelperService();
    }
    HomeUrlHelper.prototype.generateLegacyToken = function (paramsArg) {
        var url = environment.server.api.auth + "/api/token/legacy/generateLegacyToken";
        var params = paramsArg || {};
        if (typeof params.hash === 'undefined') {
            params.hash = localStorage.getItem('hash');
        }
        if (typeof params.showHeader === 'undefined') {
            params.showHeader = false;
        }
        url = this.addUrlParam(url, params);
        return this.httpClient.get(url).pipe(map(mapResponseWithData));
    };
    HomeUrlHelper.prototype.generateDynamoPortalToken = function () {
        var url = environment.server.api.auth + "/api/token/dynamo/getportaldata";
        return this.httpClient.get(url).pipe(map(mapResponseWithData));
    };
    HomeUrlHelper.prototype.generateClimaVistaUrl = function () {
        var userInfo = JSON.parse(localStorage.getItem('userInfo'));
        var userName = this.authService.user.userName;
        var url = environment.server.api.dynamo + "/Georeferencing/GetClimaVistaLink/" + userInfo.cuit;
        return this.httpClient.get(url, { headers: {
                'x-authorization': localStorage.getItem('tk'),
                'x-branchOffice': localStorage.getItem('branchOffice') || '-1',
                'username': userName,
            } }).pipe(map(mapResponseWithData));
    };
    HomeUrlHelper.prototype.urlByIndexJSON = function (JSONSource, levels, key) {
        if (key === void 0) { key = 'items'; }
        var ls = levels && levels.length;
        switch (ls) {
            case 1:
                return JSONSource && JSONSource[levels[0] * 1];
            case 2:
                return JSONSource && JSONSource[levels[0] * 1][key][levels[1] * 1];
            case 3:
                return JSONSource && JSONSource[levels[0] * 1] && JSONSource[levels[0] * 1][key] && JSONSource[levels[0] * 1][key][0];
        }
    };
    HomeUrlHelper.prototype.addUrlParam = function (url, params, redirectTo) {
        if (url === void 0) { url = ''; }
        if (params === void 0) { params = {}; }
        var ps = Object.keys(params);
        var paramsQuery = '';
        var count = 0;
        ps.forEach(function (p) {
            if (count > 0) {
                paramsQuery += '&';
            }
            paramsQuery += p + '=' + params[p];
            count++;
        });
        var redirectToUrl = redirectTo ? '&ReturnUrl=' + redirectTo : '';
        var urlWithParams = url.includes('?') ? url.replace('?', '?' + paramsQuery + '&') : url + '?' + paramsQuery;
        return urlWithParams + redirectToUrl;
    };
    HomeUrlHelper.prototype.urlByOrigin = function (url, origin) {
        switch (origin) {
            case 'LEGACY_PORTAL':
                return environment.server.web.legacy + 'portalscnet/productores' + url;
            case 'POLICY':
                return '/' + url;
            case 'LEGACY_BASE':
                return environment.server.web.legacy + url;
            case 'DYNAMO_BASE':
                return environment.server.web.dynamo + url;
            case 'CLAIM':
                var pass = localStorage.getItem('hash');
                return url + (pass ? '&p=' + pass : '');
            case 'PORTAL_TD_HOGAR':
                return environment.server.web.combinedFamily + url;
            default:
                return url;
        }
    };
    HomeUrlHelper.prototype.addTokenUrlItem = function (url, tokenType, options, redirectTo) {
        var _this = this;
        return new Observable(function (observer) {
            switch (tokenType) {
                case 'LEGACY_PORTAL':
                    _this.generateLegacyToken(options)
                        .subscribe(function (token) {
                        observer.next(_this.addUrlParam(url, { nuevoportaltoken: token }, redirectTo));
                        observer.complete();
                    }, function (error) {
                        observer.next(url);
                        observer.complete();
                    });
                    break;
                case 'NUEVO_PORTAL_TOKEN':
                    _this.generateLegacyToken(options)
                        .subscribe(function (token) {
                        observer.next(url + "&nuevoportaltoken=" + token);
                        observer.complete();
                    }, function (error) {
                        observer.next(url);
                        observer.complete();
                    });
                    break;
                case 'DYNAMO':
                    _this.generateDynamoPortalToken()
                        .subscribe(function (data) {
                        observer.next(_this.addUrlParam(url, {
                            uriToken: data.token,
                            usr: data.encryptedUsername,
                            cuit: data.cuit
                        }, redirectTo));
                        observer.complete();
                    }, function (error) {
                        observer.next(url);
                        observer.complete();
                    });
                    break;
                case 'CLIMAVISTA':
                    _this.generateClimaVistaUrl()
                        .subscribe(function (response) {
                        observer.next(response.link);
                        observer.complete();
                    });
                    break;
                case 'TOKEN_TD':
                    observer.next(_this.addUrlParam(url, { token: localStorage.getItem('tk') }));
                    observer.complete();
                    break;
                default:
                    observer.next(url);
                    observer.complete();
            }
        });
    };
    HomeUrlHelper.prototype.shouldBeRouted = function (page) {
        return page && page.route && page.route.length;
    };
    HomeUrlHelper.prototype.setJSONIndex = function (key, i0, i1, i2) {
        if (key === void 0) { key = ''; }
        if (i0 === void 0) { i0 = 0; }
        if (i1 === void 0) { i1 = -1; }
        if (i2 === void 0) { i2 = -1; }
        return key + '.' + i0 + (i1 >= 0 ? '.' + i1 : '') + (i2 >= 0 ? '.' + i2 : '');
    };
    HomeUrlHelper.prototype.getFromJSON = function (json, index) {
        var levels = index && index.split('.');
        var keys = json && Object.keys(json);
        var result = this.array.cloneDeep(json[keys[levels[0]]]);
        levels.shift();
        return this.urlByIndexJSON(result, levels);
    };
    HomeUrlHelper.prototype.urlItemMode = function (mode, urlParsed, categoryKey) {
        var iframe = document.getElementById('polizaLogs');
        var iframeWindowLogs = iframe && iframe['contentWindow'];
        switch (mode) {
            case 'BACKGROUND':
                this.downloadService.download(urlParsed)
                    .subscribe(function (_) {
                    console.log('downloaded', urlParsed);
                });
                break;
            case 'POPUP':
                var title = 'name';
                var w = 800;
                var h = 600;
                var left = (screen.width / 2) - (w / 2);
                var top_1 = (screen.height / 2) - (h / 2);
                var feature = 'toolbar=no, location=no, directories=no, status=no, menubar=no, copyhistory=no, width=' +
                    w + ', height=' + h + ', top=' + top_1 + ', left=' + left;
                window.open(urlParsed, title, feature);
                break;
            case 'TAB':
                window.open(urlParsed);
                break;
            case 'CALL_NEW_QUOTE_AUTO':
                if (iframeWindowLogs) {
                    this.homeService.sendMsg(iframeWindowLogs, { newQuotation: true, categoryKey: categoryKey });
                }
                else {
                    window.parent.postMessage({ newQuotation: true, categoryKey: categoryKey }, '*');
                }
                break;
            case 'CALL_NEW_QUOTE_HOME':
                this.homeService.sendMsg(iframeWindowLogs, { newQuotation: true });
                break;
            case 'EMBEDDED':
                break;
        }
    };
    HomeUrlHelper.prototype.getUrlSoportePas = function (path) {
        if (path === undefined) {
            path = '';
        }
        var jwt = localStorage.getItem('tk');
        var url = environment.server.web.dynamoFaq + path + '?jwt=' + jwt;
        return url;
    };
    return HomeUrlHelper;
}());
export { HomeUrlHelper };
